import React, { FunctionComponent } from 'react';
import { PasswordStrengthProps } from './PasswordStrength.types';
import styled from 'styled-components';
import { testPassword } from '../../util/password.util';

const passIcon = <i className="fas fa-check" />;
const failIcon = <i className="fas fa-times" />;
const neutralIcon = <i className="far fa-circle" />;

const List = styled.ul`
  font-size: 14px;
  list-style-type: none;
  padding-left: 1rem;

  &:first-child {
    padding: 0rem 0 0.5rem 0;
  }

  li {
    i {
      padding-right: 0.25em;
    }

    &.neutral {
      color: gray;
    }

    &.fail {
      color: red;
    }

    &.pass {
      color: #1ca61c;
    }
  }
`;

export const PasswordStrength: FunctionComponent<
  PasswordStrengthProps
> = props => {
  const result = testPassword(props.value!);

  return (
    <div>
      <List data-testid="password-requirements">
        <li className={result.length ? 'pass' : 'fail'}>
          <span>
            {result.length ? passIcon : failIcon}
            At least 8 characters in length
          </span>
        </li>
        <li className={result.characters ? 'pass' : 'fail'}>
          <span>
            {result.characters ? passIcon : failIcon}
            Contain at least 3 of the following 4 types of characters:
          </span>
          <List>
            <li className={result.lower ? 'pass' : 'neutral'}>
              {result.lower ? passIcon : neutralIcon}
              Lower case letters (a-z)
            </li>
            <li className={result.upper ? 'pass' : 'neutral'}>
              {result.upper ? passIcon : neutralIcon}
              Upper case letters (A-Z)
            </li>
            <li className={result.numeric ? 'pass' : 'neutral'}>
              {result.numeric ? passIcon : neutralIcon}
              Numbers (i.e. 0-9)
            </li>
            <li className={result.special ? 'pass' : 'neutral'}>
              {result.special ? passIcon : neutralIcon}
              Special characters (e.g. !@#$%^&*)
            </li>
          </List>
        </li>
      </List>
    </div>
  );
};
